import {LayerDef} from "./ts/LayerDef";
import {WainwrightsLayerDef} from "./ts/WainwrightsLayerDef";

export function setVisibilityOfLayers(
    params: URLSearchParams,
    layerDefs: LayerDef[],
    wainwrightsLayerDef: WainwrightsLayerDef
) {
    if (params.get("all")) {
        layerDefs.forEach((ld) => {
            ld.getGroup()
                .getLayers()
                .forEach((l) => {
                    l.setVisible(true);
                });
            ld.getGroup().setVisible(true);
        });
    }

    if (params.get("ld")) {
        wainwrightsLayerDef.getGroup().setVisible(true);
        wainwrightsLayerDef
            .getGroup()
            .getLayers()
            .forEach((l) => {
                l.setVisible(true);
            });
    }

    if (params.get("visited") || params.get("unvisited")) {
        const index = params.get("visited") ? 1 : 0;

        layerDefs.forEach((ld) => {
            const grp = ld.getGroup();
            grp.setVisible(true);

            grp.getLayers().forEach((l, i) => {
                l.setVisible(i === index);
            });
        });
    }
}
